import { forwardRef, Ref, ForwardRefRenderFunction } from 'react';
import MuiIconButton, { IconButtonProps } from '@mui/material/IconButton';

import { Icon, IconProps } from 'common/components/Icon';

export interface IProps {
    iconPath: IconProps['path'];
    iconSize?: IconProps['size'];
    iconSizeSm?: IconProps['sizeSm'];
}

type IconButtonComponentProps<C extends React.ElementType = 'button'> =
    IconButtonProps<C, { component?: C } & IProps>;

const BaseIconButton: ForwardRefRenderFunction<
    HTMLButtonElement,
    IconButtonComponentProps
> = ({ iconPath, iconSize, iconSizeSm, ...other }, ref) => (
    <MuiIconButton color="inherit" ref={ref} {...other}>
        <Icon path={iconPath} size={iconSize} sizeSm={iconSizeSm} />
    </MuiIconButton>
);

export const IconButton = forwardRef(BaseIconButton) as <
    C extends React.ElementType = 'button',
>(
    props: IconButtonComponentProps<C> & {
        ref?: Ref<HTMLButtonElement>;
    }
) => React.ReactElement | null;
